import React, { useState, useEffect } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { CloudOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import axios from 'axios';
import dayjs from 'dayjs';
import { MOODS, moodReply } from '../config/moods';

// 每天每个用户只弹一次
const todayKey = (uid) => `mood_checkin_${uid || 'guest'}_${dayjs().format('YYYY-MM-DD')}`;

const getToken = () =>
  localStorage.getItem('token') ||
  (localStorage.getItem('auth-storage') ? JSON.parse(localStorage.getItem('auth-storage')).state.token : '');

const MoodCheckin = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1); // 1=填写 2=回应
  const [mood, setMood] = useState('');
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [reply, setReply] = useState('');

  useEffect(() => {
    if (!user?.id) return;
    try {
      if (!localStorage.getItem(todayKey(user.id))) {
        setStep(1); setMood(''); setContent(''); setReply('');
        setOpen(true);
      }
    } catch (_) {}
  }, [user?.id]);

  const markDone = () => { try { localStorage.setItem(todayKey(user?.id), '1'); } catch (_) {} };
  const skip = () => { markDone(); setOpen(false); };
  const finish = () => { setOpen(false); navigate('/'); };

  const record = async () => {
    if (!mood) { message.warning('先选一个此刻的心情吧～'); return; }
    setSaving(true);
    try {
      const r = await axios.post(
        '/emotions/diary',
        { content: content.trim(), mood },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      if (r.data?.success) {
        markDone();
        setReply(moodReply(mood));
        setStep(2);
      } else {
        message.error(r.data?.message || '记录失败');
      }
    } catch (e) {
      message.error('记录失败');
    } finally {
      setSaving(false);
    }
  };

  if (!user?.id) return null;

  return (
    <Modal open={open} footer={null} closable={false} maskClosable={false} centered width={360} styles={{ body: { padding: 20 } }}>
      {step === 1 ? (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 6 }}>🌤</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#1f2430' }}>今天心情如何？</div>
          <div style={{ fontSize: 13, color: '#8c8c8c', margin: '6px 0 16px' }}>学习、工作、生活，顺利如意吗？</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center', marginBottom: 14 }}>
            {MOODS.map((m) => (
              <span
                key={m.key}
                onClick={() => setMood(m.key)}
                style={{
                  cursor: 'pointer', userSelect: 'none', padding: '5px 12px', borderRadius: 18, fontSize: 14,
                  border: `1px solid ${mood === m.key ? m.color : '#eee'}`,
                  background: mood === m.key ? m.color : '#fafafa',
                  color: mood === m.key ? '#fff' : '#555',
                }}
              >
                {m.emoji} {m.key}
              </span>
            ))}
          </div>
          <Input.TextArea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="想说点什么吗？（可不填）"
            autoSize={{ minRows: 2, maxRows: 4 }}
            maxLength={500}
            style={{ borderRadius: 10, marginBottom: 16 }}
          />
          <div style={{ display: 'flex', gap: 10 }}>
            <Button block onClick={skip} style={{ borderRadius: 10, height: 42 }}>跳过</Button>
            <Button block type="primary" icon={<CloudOutlined />} loading={saving} onClick={record} style={{ borderRadius: 10, height: 42 }}>记录心情</Button>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '6px 4px' }}>
          <div style={{ fontSize: 44, marginBottom: 10 }}>{(MOODS.find((m) => m.key === mood) || {}).emoji || '🌱'}</div>
          <div style={{ fontSize: 16, color: '#1f2430', lineHeight: 1.75, padding: '0 6px', marginBottom: 20 }}>{reply}</div>
          <Button block type="primary" onClick={finish} style={{ borderRadius: 10, height: 44 }}>好的</Button>
        </div>
      )}
    </Modal>
  );
};

export default MoodCheckin;
